import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Sun, Moon } from "lucide-react";
import { WaldLogo } from "./WaldLogo";
import { useTheme } from "../../context/ThemeContext";

const nav = [
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/products", label: "Products" },
  { to: "/insights", label: "Insights" },
  { to: "/about", label: "About" },
];

export const Navbar = () => {
  const { theme, toggle } = useTheme();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur-[2px] transition-colors ${
        scrolled ? "shadow-[0_1px_0_0_hsl(var(--border))]" : ""
      }`}
    >
      <div className="container-wald flex h-16 items-center justify-between">
        <WaldLogo />
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link text-sm ${isActive ? "!opacity-100 text-[color:var(--wald-copper)]" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="theme-toggle-btn"
            onClick={toggle}
            aria-label="Toggle theme"
            className="p-2 border border-border rounded-sm hover:border-[color:var(--wald-copper)] transition-colors"
          >
            {theme === "dark" ? <Sun size={16} strokeWidth={2} /> : <Moon size={16} strokeWidth={2} />}
          </button>
          <Link
            to="/contact"
            data-testid="nav-contact-cta"
            className="hidden lg:inline-flex btn-copper text-sm py-2 px-4 whitespace-nowrap"
          >
            Book Discovery Call
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 border border-border rounded-sm"
            aria-label="Toggle menu"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="container-wald flex flex-col gap-1 py-4">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-mobile-${item.label.toLowerCase()}`}
                className="py-3 border-b border-border text-sm nav-link"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-contact-cta"
              className="mt-3 btn-copper justify-center"
            >
              Book Discovery Call
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
